import withAuth from './../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import React, { useState, useEffect } from 'react';
import PermissionRolesServices from '../../../services/permroles.service.js';
import LoaderOverlay from './../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { MESSAGES } from '../../constants/constants.js';


const Permissions = () => { 


  const [loading, setLoading] = useState(false);
  const [permssionsData , setPermssionsData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();

  
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  
  const columns = [
    {
      name: 'Order ID',
      selector: row => row.order_code,
      sortable: true,
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => row.start_date,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      {
        row.status == 'P' && (
          <span className="badge badge-pill badge-soft-pending font-size-11">Pending</span>
        )
      }
      {
        row.status == 'AA' && (
          <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>
        )
      }
       {
        row.status == 'AR' && (
          <span className="badge badge-pill badge-soft-danger font-size-11">Rejected</span>
        )
      }
       
      {
        row.status == 'R' && (
          <span className="badge badge-pill badge-soft-danger font-size-11">Raised</span>
        )
      }
        {
          row.status == 'RF' && (
          <span className="badge badge-pill badge-soft-warning font-size-11">Refund</span>
        )
      }
        {
          row.status == 'C' && (
          <span className="badge badge-pill badge-soft-success font-size-11">Paid</span>
        )
      }
      </>,
      
      sortable: true,
    },
    {
      name: 'Total',
      selector: row => '₹' + row.amount,
      sortable: true,
    },
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
                            row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method}
      
      </>
      
      ,
      sortable: true,
    },
    {
        name: "Actions",
        button: true,
        cell: row =>
         <>
               <a className="fview tooltip" style={{'cursor':'pointer'}}  >
           <i className="fa fa-eye" style={{ color: 'black' }}/>
            <span className="tooltiptext">View</span>
          </a>
              <a className="flock tooltip"style={{'cursor':'pointer'}}>
              <i className={'fa fa-unlock'}  style={{ color: 'black' }}/>
              <span className="tooltiptext">
                <>
                 Lock
                </>
      
              </span>
            </a>
            <a className={`fedit tooltip`} style={{'cursor':'pointer'}}  onClick={() => editMerchant(row)}>
              <i  className={`fa fa-edit`}   style={{ color: 'black' }}/>
              <span className="tooltiptext">Edit</span>
            </a>
            <a className="ftrash tooltip" style={{'paddingRight':'25px', 'cursor':'pointer'}}>
              <i className="fa fa-trash"   style={{ color: 'black' }}/>
              <span className="tooltiptext">Delete</span>
            </a>
         
            </>
     
      }
  ];
const viewTransaction = (id) => {
  navigate(`/transaction/${id}`)
}


  const listTransactions = () => {
   
    let permissions =  PermissionRolesServices.getPermissions()
  
    setLoading(true);
   
    permissions.then(response => {
      console.log(response)
      const records = response.data.data.list
      setPermssionsData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }

  const addNewPermission = () => {

  }


  useEffect(() => {
   
    listTransactions(false,0,10,"P");
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

  
  

    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Permissions</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
        <div className="filterBtn">
        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        aria-controls="examplemgm" /></label></div>
                        <div className="dt-buttons ui-buttonset"><a className="dt-button ui-button ui-state-default ui-button-text-only btn btn-success ddfg" tabIndex={0} aria-controls="examplemgm"><span className="ui-button-text" onClick={addNewPermission}>Add Permission</span></a></div>
                  </div>

   
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
  
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={permssionsData }
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                             
                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(Permissions));